module.exports = __webpack_public_path__ + "img/dragon.1db2379e.gif";